import propTypes from 'prop-types';

export const productPropTypes = propTypes.shape({
  modelName: propTypes.string,
  sku: propTypes.string,
  images: propTypes.arrayOf(
    propTypes.shape(
      {
        url: propTypes.string,
      },
    ),
  ),
  manufacturer: propTypes.shape({
    name: propTypes.string,
  }),
  productDetails: propTypes.shape({
    size: propTypes.string,
  }),
});
